import { render, staticRenderFns } from "./dev-header-user.vue?vue&type=template&id=92554f6e&"
import script from "./dev-header-user.vue?vue&type=script&lang=ts&"
export * from "./dev-header-user.vue?vue&type=script&lang=ts&"
import style0 from "./dev-header-user.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports